'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _footer = require('../../footer');

var _footer2 = _interopRequireDefault(_footer);

var _publicToolbar = require('../../public-toolbar');

var _publicToolbar2 = _interopRequireDefault(_publicToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeController = function HomeController($document, config) {
  _classCallCheck(this, HomeController);

  this.config = config;
  this._svc = {
    $document: $document
  };

  $document.scrollTop(0, 1000);
};

exports.default = angular.module('ifeis.routes.home', ['ui.router', 'ifeis.public-toolbar', 'ifeis.footer']).config(function ($stateProvider) {
  $stateProvider.state('home', {
    url: '/',
    controller: 'HomeController',
    controllerAs: 'ctrl',
    template: require('./tpl.html')
  });
}).controller('HomeController', HomeController);


//////////////////
// WEBPACK FOOTER
// ./routes/home/index.js
// module id = 599
// module chunks = 0